import { Auth0Client } from '@auth0/auth0-spa-js';
import { CONFIG } from './config';

class AuthenticationService {
    user: {
        name: any;
        email: any;
        picture: any;
        roles: any;
        accessToken: any;
    } | null = null;

    auth0 = new Auth0Client({
        audience: 'https://sample-provider-api.landr.com',
        domain: `${CONFIG.AUTH0_DOMAIN}`,
        client_id: `${CONFIG.AUTH0_CLIENT_ID}`, // eslint-disable-line
        redirectUri: `${window.location.origin}/callback`,
        responseType: 'token id_token',
        scope: 'openid profile email',
    });

    async login(pathAndQuery: string): Promise<void> {
        /* eslint-disable no-console */
        try {
            await this.auth0.loginWithRedirect({
                redirect_uri: `${window.location.origin}/callback?${pathAndQuery}`, // eslint-disable-line
            });
        } catch (err) {
            console.log('Log in failed', err);
        }
        /* eslint-enable no-console */
    }

    async getAdminProfile(): Promise<{
        name: string;
        email: string;
        picture: string;
        roles: never[];
        accessToken: string;
    }> {
        const user = await this.auth0.getUser();
        this.user = {
            picture: user?.picture,
            name: user?.name,
            email: user?.email,
            roles: user?.['https://sample-provider-api.landr.com/roles'],
            accessToken: await this.auth0.getTokenSilently(),
        };

        return this.user;
    }

    isAuthenticated(): Promise<boolean> {
        return this.auth0.isAuthenticated();
    }

    async handleRedirectCallback(): Promise<void> {
        /* eslint-disable no-console */
        try {
            await this.auth0.handleRedirectCallback();
        } catch (err) {
            console.log('Error parsing redirect:', err);
        }
        /* eslint-enable no-console */
    }

    signout(): void {
        /* eslint-disable no-console */
        try {
            this.user = null;
            this.auth0.logout({
                returnTo: window.location.origin,
            });
        } catch (err) {
            console.log('Log out failed', err);
        }
        /* eslint-enable no-console */
    }
}

const authenticationService = new AuthenticationService();

export default authenticationService;
